import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

const useStudentAbsencesCount = (params: { semesterId?: string }) =>
  useQuery({
    queryKey: ['panelAbsencesSummaryRetrieveCount', params],
    staleTime: 60 * 100,
    queryFn: async () => {
      const students = await httpService.panel.panelAbsencesSummaryRetrieve({
        semester_id: params.semesterId,
        page_size: 1,
        page: 1,
        fetchKeys: {
          id: true
        }
      })
      return students.count
    }
  })

export default useStudentAbsencesCount
